import { AnimatePresence, motion } from 'motion/react';

import { animMerge, fadeIn, slideHorizontal } from '@/utils/animations/commom';
import { DomainsNames } from '@/utils/courses';

import CoursesTreeRoot from './CoursesTreeRoot';
import UnitsFileTree from './CourseTreeSecond';
import useTreeOrquester from './useTreeOrquester';

const components: Record<DomainsNames, React.FC> = {
  domain1: CoursesTreeRoot,
  domain2: UnitsFileTree,
};

const transition = animMerge(fadeIn, slideHorizontal(-20));

export default function CourseFileTreeOrquester() {
  const { domain } = useTreeOrquester();

  const activeDomain: DomainsNames = domain ?? 'domain1';
  const Component = components[activeDomain];

  return (
    <AnimatePresence mode="wait">
      <motion.div key={activeDomain} {...transition}>
        <Component />
      </motion.div>
    </AnimatePresence>
  );
}
